<script>
  import atividadeServico from '~modulos/atividade/servico';
  
  export default {
    props: {
      atividades: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        tipoAtividades: [],
        atividade: ''
      }
    },
    computed: {
      tipoAtividadesFiltered() {
        return this.tipoAtividades.filter(tipoAtividade => {
          return !this.atividades.some(atividade => atividade.idAtividade === tipoAtividade.idAtividade);
        });
      }
    },
    methods: {
      nomeTipoAtividade(id) {
        return this.tipoAtividades.find(atividade => {
          return atividade.idAtividade === id;
        }).nomeAtividade;
      },
      carregarTipoAtividades() {
        return atividadeServico.
          lista()
          .then(tipoAtividades => {


            this.tipoAtividades = tipoAtividades
              .filter((atividade) => atividade.fgPortal == '1' || atividade.fgPortal == 1)
              .sort((atividade1, atividade2) => {
                if (atividade1.nomeAtividade > atividade2.nomeAtividade) {
                  return 1;
                }
                if (atividade1.nomeAtividade < atividade2.nomeAtividade) {
                  return -1;
                }
                return 0;
              });
          });
      },
      deletar(indice) {
        this.atividades.splice(indice, 1);
      },
      async editar(indice) {
        const atividade = this.atividades[indice];
        this.atividades.splice(indice, 1);

        this.atividade = atividade.idAtividade;
      },
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              this.adicionar();
            }
          })
      },
      adicionar() {
        this.atividades.push({
          idAtividade: this.atividade,
        });

        this.atividade = '';
        this.$validator.reset();
      },
    },
    mounted() {
      this.carregarTipoAtividades();
    },
  }
</script>

<template>
  <div>
    
    <div class="table-responsive">
      <table class="table table-hover table-pointer">
        <thead>
          <tr>
            <th>Atividade</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(atividade, indice) in atividades">
            <td>{{ nomeTipoAtividade(atividade.idAtividade) }}</td>
            <td class="action">
              <button type="button"
                      class="btn btn-warning btn-xs"
                      @click="editar(indice)">
                <i class="fa fa-edit"></i>
              </button>
            </td>
            <td class="action">
              <button type="button"
                      class="btn btn-danger btn-xs"
                      @click="deletar(indice)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="atividades.length === 0">
            <td colspan="5" class="text-center">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('atividade')}">
          <label class="control-label" for="atividade">Atividade</label>

          <select class="form-control"
                  id="banco"
                  v-model="atividade"
                  data-vv-name="atividade"
                  data-vv-as="atividade"
                  v-validate="'required'"
                  @change="carregarTipoAtividades">
            <option v-if="tipoAtividadesFiltered.length !== 0" value="">Selecione...</option>
            <option v-else value="">Nenhuma atividade disponível</option>
            <option :value="tipoAtividade.idAtividade" v-for="tipoAtividade in tipoAtividadesFiltered">{{ tipoAtividade.nomeAtividade }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('atividade')">{{ errors.first('atividade') }}</p>
        </div>
      </div>


    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <button
            type="button"
            class="btn btn-success"
            @click="validar">
            <i class="fa fa-plus"></i> Adicionar atividade
          </button>
        </div>
      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/web-fornecedor/componentes/compartilhado/FormAtividades.vue